import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Option, Select } from "@natera/form";
import { DISTANCE_OPTIONS_MI } from "@app/provider/bloodDraw";

import "./milesSelector.scss";

const messages = defineMessages({
  milesSelectorLabel: {
    id: "milesSelectorLabel",
    defaultMessage: "Distance",
  },
  milesSelectorOption: {
    id: "milesSelectorOption",
    defaultMessage: "{miles} miles",
  },
});

export interface MilesSelectorProps {
  value: number;
  onSelect: (miles: number) => void;
}

export const MilesSelector: FC<MilesSelectorProps> = ({ value, onSelect }) => {
  const intl = useIntl();

  return (
    <div className="miles-selector">
      <Select
        labelId="milesSelector"
        outlined
        floating
        value={String(value)}
        onValueChange={(next: string) => onSelect(Number(next))}
        aria-label={intl.formatMessage(messages.milesSelectorLabel)}
        data-testid="miles_selector"
      >
        {DISTANCE_OPTIONS_MI.map((miles) => (
          <Option
            key={miles}
            id={`miles-option-${miles}`}
            value={String(miles)}
            data-testid={`miles_option_${miles}`}
            aria-selected={value === miles}
          >
            {intl.formatMessage(messages.milesSelectorOption, { miles })}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export default MilesSelector;
